/**
 * 接口域名的管理
 */
const environment = process.env.VUE_APP_ENV||'development'
let url;
let https;
let http;
let abUrl;
let path;
let newPath;
let system;
// 根据环境确定API基地址
    // http='http://parkinglot.testweb.easthuaxin.com',
switch (environment) {
    case 'production':
    url='http://parkinglot.interface.easthuaxin.com',
    // url='http://192.168.101.88:12188',
    // url='https://parkinglot.interface.easthuaxin.com',
    // 根据url开头https截取，匹配判断走下面两个中的一个
    https= 'https://parkinglot.scan.easthuaxin.com',
    http= 'http://parkinglot.scan.easthuaxin.com',
    // http= 'http://192.168.101.194:8081/',
    // http='http://parkinglot.testweb.easthuaxin.com',
    abUrl= 'https://api.anbokeji.net',
    path="/api",
    newPath= "/api",
    system="/system"
        break;
    case 'development':
    // url= 'https://parkinglot.interface.easthuaxin.com',
    url='http://parkinglot.interface.easthuaxin.com',
    // url='http://192.168.101.88:12188',
    // 根据url开头https截取，匹配判断走下面两个中的一个
    https= 'https://parkinglot.scan.easthuaxin.com',
    http= 'http://parkinglot.scan.easthuaxin.com',
    // http='http://parkinglot.testweb.easthuaxin.com',
    abUrl= 'https://api.anbokeji.net',
    path= "/api",
    newPath= "/api",
    system="/system"
        break;
    default:
        // url= 'https://parkinglot.interface.easthuaxin.com',
        // url='http://192.168.101.88:12188',
        url='http://parkinglot.interface.easthuaxin.com',
        // 根据url开头https截取，匹配判断走下面两个中的一个
        https= 'https://parkinglot.scan.easthuaxin.com',
        http= 'http://parkinglot.scan.easthuaxin.com',
        // http='http://parkinglot.testweb.easthuaxin.com',
        abUrl= 'https://api.anbokeji.net',
        path= "/api",
        newPath= "/api",
        system="/system"
        break;
}
const base = {
    url: url,
    // 根据url开头https截取，匹配判断走下面两个中的一个
    https: https,
    http:http,
    abUrl: abUrl,
    path: path,
    newPath: newPath,
    system: system
}

export default base;
